import * as types from './mutations-types'

export default {
  [types.setContract] (state, contract) {
    state.contract = contract
  },
  [types.setContractPlan] (state, contractPlan) {
    state.contractPlan = contractPlan
  },
  [types.setContracts] (state, contracts) {
    state.contracts = contracts
  },
  [types.setContractAfterInactive] (state, payload) {
    state.contracts[payload.index].status = payload.contract.status
  },
  [types.setFilterContract] (state, obj) {
    state.filterContracts[obj.key] = obj.value
  },
  [types.setFilteredPlans] (state, obj) {
    state.filteredPlans[obj.key] = obj.value
  },
  [types.clearFilterContract] (state, key) {
    delete state.filterContracts[key]
  },
  [types.clearFilterContracts] (state) {
    state.filterContracts = {}
  },
  [types.clearFilteredPlans] (state) {
    state.filteredPlans = {}
  },
  [types.changeContractPlan] (state, obj) {
    state.contract.contract_plans = [obj]
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/contracts/vuex/mutations.js